import { Component, OnInit } from '@angular/core';
import { ThemingService } from 'src/app/theming.service';


interface LogType {
  id: string;
  name: string;
  allowName: string;
  allowValue: number;
}

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss']
})
export class LogsComponent implements OnInit {
  shopSubscription: any;

  constructor(
    public themingService: ThemingService,
  ) { }

  logTypes: LogType[] = [
    //no-logs
    { id: 'sales', name: 'SALES', allowName: "sales", allowValue: 0 },
    { id: 'beneficiaries', name: 'BENEFICIARIES', allowName: "beneficiaries", allowValue: 0 },
    { id: 'users', name: 'USERS', allowName: "clients", allowValue: 0 },
    // Agrega más tipos aquí
    // { id: 'users', name: 'Usuarios', icon: 'people' },
    // { id: 'system', name: 'Sistema', icon: 'settings' }
  ];

  selectedLog: string = 'no-logs';

  ngOnInit(): void {
    this.shopSubscription = this.themingService.shopTheming[0].shopSubscription;
    this.logTypes.forEach(logType => {
      if (this.shopSubscription.shopLogsAllow[logType.allowName] == 1) {
        logType.allowValue = 1;
      }
    });


    // Selecciona el primer tipo de log por defecto si existe
    // if (this.logTypes.length > 0) {
    //   this.selectedLog = this.logTypes[0].id;
    // }
  }

  selectLog(logId: string): void {
    this.selectedLog = logId;
  }

}
